<div>
    <div class="row">
        <span class="col-10">
            {{texts.summa}}
        </span>
        <span class="col-2 value" aid="produktval-sum-value">
            {{totalsummaAsText}}
        </span>
    </div>
    <div class="row">
        <span class="col-10">
           {{texts.timmerandel}}
        </span>
        <span class="col-2 value">
            {{timmerandelAsText}}
        </span>
    </div>
    <div class="row">
        <span class="col-10">
            {{texts.grot}}
        </span>
        <span class="col-2 value">
            {{simuleratUtbyteGrotAsText}}
        </span>
    </div>
</div>